import React from "react"
import {Swiper, SwiperSlide} from "swiper/react"
import {Autoplay, Mousewheel} from "swiper/modules"
import RyderLivescoringMatchCard from "@/components/RyderLivescoring/RyderLivescoringMatchCard"

const RyderLivescoringSessionNin9rsView = ({
    teams,
    session,
    teamIds,
    showHeader,
    colors,
    useSwiper,
    wrapperStyle,
    wrapperRef,
    slideCount,
    matchCardRef,
    onWheel,
    swiperRef,
    customDesign,
    teamColors
}) => {
    return (
        <section className="mb-6 flex flex-col h-auto sm:h-screen lg:h-screen">
            {showHeader && (
                <div className="w-full max-w-screen-xl mx-auto my-10">
                    <div className="flex w-full justify-between items-center">
                        <div className="headerScore" style={{ backgroundColor: teamColors[teamIds[0]]}}>
                            <label>
                                {teams[teamIds[0]].score[session.id]}
                            </label>
                        </div>
                        <div className="headerInfoContainer">
                            <h3 className="headerName">
                                {session.name}
                            </h3>
                            <h4 className="headerModality">
                                {session.modality}
                            </h4>
                            <p className="headerDate">
                                {session.date}
                            </p>
                        </div>
                        <div className="headerScore" style={{ backgroundColor: teamColors[teamIds[1]]}}>
                            <label>
                                {teams[teamIds[1]].score[session.id]}
                            </label>
                        </div>
                    </div>
                </div>
            )}

            {useSwiper ? (
                <div
                    ref={wrapperRef}
                    className="flex-1 relative w-full 2xl:max-w-full px-4 sm:px-3 overflow-hidden"
                    onWheel={onWheel}
                    style={wrapperStyle}
                >
                    <Swiper
                        direction="vertical"
                        slidesPerView={slideCount}
                        spaceBetween={0}
                        loop={false}
                        grabCursor
                        modules={[Autoplay, Mousewheel]}
                        autoplay={{
                            delay: 10000,
                            disableOnInteraction: false,
                        }}
                        speed={3000}
                        style={{height: "100%"}}
                        onBeforeInit={(s) => {
                            swiperRef.current = s
                        }}
                    >
                        {session.matches.map((match, idx) => (
                            <SwiperSlide key={match.id} className="swipperContainer">
                                <div ref={idx === 0 ? matchCardRef : null} className="w-full flex justify-center">
                                    <RyderLivescoringMatchCard
                                        className="w-full"
                                        match={match}
                                        teamColors={teamColors}
                                        leftTeamId={teamIds[0]}
                                        rightTeamId={teamIds[1]}
                                        colors={colors}
                                        customDesign={customDesign}
                                    />
                                </div>
                            </SwiperSlide>
                        ))}

                        <SwiperSlide key="ph" className="swipperContainer">
                            <div className="w-full opacity-0 pointer-events-none">
                                <RyderLivescoringMatchCard
                                    className="w-full"
                                    match={session.matches[0]}
                                    teamColors={teamColors}
                                    leftTeamId={teamIds[0]}
                                    rightTeamId={teamIds[1]}
                                    colors={colors}
                                    customDesign={customDesign}
                                />
                            </div>
                        </SwiperSlide>

                        {window.innerWidth >= 640 && window.innerWidth < 1024 && (
                            <SwiperSlide key="ph2" className="swipperContainer">
                                <div className="w-full opacity-0 pointer-events-none">
                                    <RyderLivescoringMatchCard
                                        className="w-full"
                                        match={session.matches[0]}
                                        teamColors={teamColors}
                                        leftTeamId={teamIds[0]}
                                        rightTeamId={teamIds[1]}
                                        colors={colors}
                                        customDesign={customDesign}
                                    />
                                </div>
                            </SwiperSlide>
                        )}
                    </Swiper>
                </div>
            ) : (
                <div className="flex-1 w-full overflow-auto">
                    <div className="flex flex-col">
                        {session.matches.map((match, idx) => (
                            <div key={match.id} className="swipperContainer">
                                <RyderLivescoringMatchCard
                                    className="w-full"
                                    match={match}
                                    teamColors={teamColors}
                                    leftTeamId={teamIds[0]}
                                    rightTeamId={teamIds[1]}
                                    colors={colors}
                                    customDesign={customDesign}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </section>
    )
}

export default RyderLivescoringSessionNin9rsView
